import { PaymentElement, useElements, useStripe } from "@stripe/react-stripe-js"
import { useCallback, useState } from "react"
import styled from "styled-components"
import { Button, OutlineButton } from "~/components"
import { Form } from "~/components/Form"
import { useTranslate } from "~/ur-react-hooks"
import { useToast } from "~/utils"

const Layout = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
`

const Title = styled.h4`
  margin: 0;
  font-size: 18px;
  color: ${(props) => props.theme.colors.gray0};
  margin-bottom: 1rem;
`

const Buttons = styled.div`
  display: flex;
  justify-content: space-between;
  gap: 1rem;
  margin-top: 2rem;

  button {
    flex: 1;
  }
`

export interface SetupEnterPaymentDetailsProps {
  title: string
  submitText: string
  redirectUrl: string
  onBack: () => void
}

const SetupEnterPaymentDetails: React.FC<SetupEnterPaymentDetailsProps> = ({
  title,
  submitText,
  redirectUrl,
  onBack,
}) => {
  const [isLoading, setLoading] = useState(false)
  const translations = useTranslate({
    title: "pay-for-subscription.title",
    back: "common.back",
    purchase: "pay-for-subscription.purchase",
  })

  const stripe = useStripe()
  const elements = useElements()

  const toast = useToast()

  const submit = useCallback(() => {
    if (!stripe || !elements) {
      return
    }

    setLoading(true)
    stripe
      .confirmSetup({
        elements,
        confirmParams: {
          return_url: redirectUrl,
        },
      })
      .then((result) => {
        if (result.error) {
          toast("error", result.error.message ?? "")
        }
      })
      .finally(() => {
        setLoading(false)
      })
  }, [stripe, elements, redirectUrl, toast])

  return (
    <Layout>
      <Form preventDefault onSubmit={submit}>
        <Title>{title}</Title>
        <PaymentElement />
        <Buttons>
          <OutlineButton type="button" onClick={onBack}>
            {translations.back}
          </OutlineButton>
          <Button disabled={!stripe || isLoading}>{submitText}</Button>
        </Buttons>
      </Form>
    </Layout>
  )
}

export default SetupEnterPaymentDetails
